const StatutMontantSimulation = {
	A_ARBITRER: 'A_ARBITRER',
	ACCEPTE: 'ACCEPTE',
	REFUSE: 'REFUSE',
} as const;

export default StatutMontantSimulation;
